<template>
    <div
            v-touch="{right: () => swipe()}"
    >
        <Videos  />
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Videos from "@/views/video/Videos";

  export default {
    name: "PlayerVideos",
    components: {Videos},
    data() {
      return {

      }
    },
    computed: {
      ...mapState(['activeplayer']),
      items(){
        return [
          {
            text: 'My Athletes',
            disabled: false,
            to: '/myathletes',
          },
          {
            text: this.activeplayer.info.firstname+' '+this.activeplayer.info.lastname,
            disabled: false,
            to: '/myathletes/profile/'+this.activeplayer.partkey,
          },
          {
            text: this.activeplayer.info.firstname+'\'s Videos',
            disabled: false,
            to: '/myathletes/profile/'+this.activeplayer.partkey+'/videos',
          },
        ]
      }
    },
    methods: {
      ...mapActions(['selectPlayer']),
      swipe(){
        this.$router.push('/myathletes/profile/'+this.activeplayer.partkey+'')
      }
    }
  }
</script>

<style scoped>

</style>